export default "__VITE_ASSET__DbHquaF3__"